module.exports = __webpack_public_path__ + "static/media/thumb2@2x.9dda54e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/features/assets/thumb2@2x.png
// module id = 109
// module chunks = 0